import type { SelectHTMLAttributes } from 'react';
import { cx } from './cx.js';

/**
 * A styled native <select>. Native on purpose: it keeps the platform's own
 * picker on phones and its keyboard behaviour everywhere, which a hand-rolled
 * listbox has to reimplement. Use Combobox instead only when the list is long
 * enough to need typeahead.
 */
export function Select({
  size = 'md',
  className,
  children,
  ...rest
}: { size?: 'sm' | 'md' } & Omit<SelectHTMLAttributes<HTMLSelectElement>, 'size'>) {
  return (
    <select {...rest} className={cx('ui-select', `ui-select--${size}`, className)}>
      {children}
    </select>
  );
}
